import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

export const ShareItemsWrapper = styled.div<{ deviceType: string }>`
  margin-left: ${(props) => (props.deviceType === 'mobile' ? '-8px' : '0px')};
  ${media.xs`
  padding-left: 16px
  `};
  display: flex;
  margin-bottom: 12px;
  .share-item-wrapper {
    padding: 4px 8px;
    height: 32px;
    cursor: pointer;
    &:hover {
      background-color: #f7f8f9;
      border-radius: 3px;
    }
    &:last-child {
      padding-bottom: 5px;
    }
  }
  .share-item-button {
    display: flex;
    align-items: center;
    outline: none;
    .share-item-words {
      padding: 0 20px;
      color: #697684;
    }
  }
`;

export const ShareQrPopupWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  @media (${mediaQuery.mobile}) {
    height: 60%;
  }
  .title {
    line-height: 22px;
    font-size: 18px;
    font-weight: 300;
    color: #333f48;
  }
  .description {
    width: 278px;
    line-height: 19px;
    font-size: 16px;
    font-weight: 300;
    color: #697684;
    text-align: center;
  }
`;
